import { render, staticRenderFns } from "./KitchenOrders.vue?vue&type=template&id=0eb422e3&"
import script from "./KitchenOrders.vue?vue&type=script&lang=js&"
export * from "./KitchenOrders.vue?vue&type=script&lang=js&"
import style0 from "./KitchenOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports